import styled from '@emotion/styled'
import { ModalProps } from 'antd/lib/modal'
import { useCallback } from 'react'
import Button from '../../components/common/Button'
import Image, { ImageNameKeys } from '../../components/common/Image'
import Modal from '../../components/common/Modal'
import Text from '../../components/common/Text'
import { mobile } from '../../utils/responsive-helper'
import { Footer } from '../Enrollment/ModalAcceptPrivacy'

const Layout = styled.div`
    padding: 24px;

  ${mobile} {
    width: calc(100vw - 32px);
    padding: 16px;
    padding-top: 24px;

    .header {
      padding-right: 32px;
    }
  }
`
const Header = styled.div`
  text-align: center;
  margin-bottom: 24px;
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  border-radius: 8px;
  gap: 16px;
`
const TextCenter = styled(Text)`
  text-align: center;
`
const ConfirmButton = styled(Button)`
  width: 200px;
`

type ModalHealthInsuranceErrorProps = {
  message: string | null,
  icon?: ImageNameKeys
  onConfirmClick: () => void
  onCloseClick: () => void
} & Required<Pick<ModalProps, 'visible'>>

const ModalHealthInsuranceError = (props: ModalHealthInsuranceErrorProps) => {
  const { message, icon = null, visible, onConfirmClick, onCloseClick } = props

  const onCancel = useCallback(() => {
    onCloseClick()
  }, [onCloseClick])

  const onConfirm = useCallback(() => {
    onConfirmClick()
  }, [onConfirmClick])

  return (
    <Modal
      hideFooter
      hideCloseIcon
      visible={visible}
      onCancel={onCancel}
      style={{ padding: 0, }}
    >
      <Layout>
        <Header>
          {icon && <Image imageName={icon} width={56} height={56} />}
        </Header>
        <Content>
          <TextCenter size={20} type="Bold">ไม่สามารถทำรายการได้</TextCenter>
          {message &&
            <TextCenter ellipsis size={16} type="Bold">
              {message}
            </TextCenter>}
          <TextCenter size={16} type="Medium">กรุณาดำเนินการใหม่อีกครั้ง ในวันที่ 1 มกราคมของปีถัดไป</TextCenter>
        </Content>
        <Footer>
          <ConfirmButton onClick={onConfirm}>
            ตกลง
          </ConfirmButton>
        </Footer>
      </Layout>
    </Modal>
  )
}

export default ModalHealthInsuranceError